// eslint-disable-next-line import/prefer-default-export
export const CREATION_STATES = {
  GETTING_STARTED: Symbol('getting started'),
  DRAWING_MODE: Symbol('drawing mode'),
  FIELD_ACTIVE: Symbol('field active'),
  CROP_ZONE_ACTIVE: Symbol('crop zone active'),
  SAVING: Symbol('saving')
};
